import React from "react";
import "./css/services.css";
import { motion } from "motion/react";
// import ServicesCard from "../../components/servicesCard/servicesCard";
import Competitions from "../../components/competitions/competitions";
import services from "./json/services.json";
import ServicesComponent from "../../components/servicesComponent/servicesComponent";

const Services = () => {

  return (
    <motion.div
      key={"empty"}
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="d-flex flex-column min-vh-100">
        <div class="col-md-12 d-flex justify-content-center mb-5">
          <div class="color-text-gris-hv">Professional Services</div>
        </div>

        

        <ServicesComponent services={services} />

        <div class="col-md-12 d-flex justify-content-center">
          <div class="color-text-body-services-hv text-center size-text-hv ">
            For further questions and general inquiries regarding the process, information,
            budget, schedule and more, feel free to reach out to me through contact
            section. I will be happy to assist you and...
          </div>
        </div>

        <div class="col-md-12 d-flex justify-content-center">
          <div class="color-text-gris-services-hv mb-5 text-center">
            ...Let’s work together!
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Services;
